import { render } from "./IconGoogle.vue?vue&type=template&id=c2e3483e"
import script from "./IconGoogle.vue?vue&type=script&lang=js"
export * from "./IconGoogle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__